'use strict';

var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');

var LoadMore = {
  request: function (e) {
    e.preventDefault();

    if (!e.target) NotificationService.warning('Ops!');

    var ajax = e.target.getAttribute('data-ajax');
    if (ajax) {
      e.target.innerHTML = 'Carregando...';

      HTTPService.get(ajax)
        .then(function (data) {
          if (e.target.getAttribute('data-outer-html')) {
            e.target.outerHTML = data;
          } else {
            e.target.innerHTML = data;
          }
        })
        .catch(NotificationService.error);
    }
  }
};

$('body').on('click tap', '.js-load-more', LoadMore.request);
